import { render, staticRenderFns } from "./CotationList.vue?vue&type=template&id=06b844b8&scoped=true"
import script from "./CotationList.vue?vue&type=script&lang=ts"
export * from "./CotationList.vue?vue&type=script&lang=ts"
import style0 from "./CotationList.vue?vue&type=style&index=0&id=06b844b8&prod&scoped=true&lang=css"
import style1 from "./CotationList.vue?vue&type=style&index=1&id=06b844b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b844b8",
  null
  
)

export default component.exports